import {get, isObject, startsWith} from 'lodash';

const HAS_PENDING_REQUEST = 'There is already a pending request, please do not submit it again.';
const SECURITY_VERIFICATION_REQUIRED = 'Additional security verification is required before this request can continue.';
const SECURITY_REQUEST_BLOCKED = 'This request was blocked by a security policy.';
const SECURITY_VERIFICATION_UNAVAILABLE = 'Security verification is temporarily unavailable. Please try again later.';
const codeMatcher = (code) => {
    switch (code) {
        case 'VERIFICATION_REQUIRED':
            return SECURITY_VERIFICATION_REQUIRED;
        case 'REQUEST_BLOCKED':
            return SECURITY_REQUEST_BLOCKED;
        case 'SECURITY_VERIFICATION_UNAVAILABLE':
            return SECURITY_VERIFICATION_UNAVAILABLE;
        case 'E_TRADE_CUT_OFF':
            return 'E_TRADE_CUT_OFF';
        case 'E_DUPLICATE':
            return 'E_DUPLICATE';
        case 'E_BAD_REQUEST':
            return 'E_BAD_REQUEST';
        case 'E_DUPLICATE':
            return 'E_DUPLICATE';
    }
};

// 取后端给的**业务错误 code** (顶层 code 优先, 再取响应体里的那个).
// 前端判定"这是哪一类错误"一律走它 —— 不靠匹配英文句子 (文案随时会改,
// 而且不同 locale 的后端文案也可能不一样).
export const getErrorCode = (error) =>
    get(error, 'code') || get(error, 'response.body.error.code');

export const getErrorMessage = (error) => {
    const code = get(error, 'code') || get(error, 'response.body.error.code');
    const securityMessage = codeMatcher(code);
    const responseMessage = get(error, 'response.body.error.message') ||
        (isObject(get(error, 'response.body.error'))
            ? false
            : get(error, 'response.body.error'));
    const errorMessage = responseMessage ||
        (code === 'HAS_PENDING_REQUEST' ? HAS_PENDING_REQUEST : securityMessage || get(error, 'message'));
    if (code && !errorMessage) {
        return codeMatcher('E_TRADE_CUT_OFF');
    }
    if(startsWith(errorMessage, 'Validation failed')){
        return 'Wrong verification code'
    }
    return errorMessage;
};
